import { atom } from 'jotai';
import { GetTwoFactorSettingsResponse } from '../../resources';
import { Loadable, LoadableState } from '../../utils';

export const twoFactorSettingsAtom = atom<LoadableState<GetTwoFactorSettingsResponse>>(Loadable.uninitialized);
